/* eslint-disable prettier/prettier */
/* eslint-disable */
/* prettier-ignore-file */
import React, { useEffect, useState } from 'react';
import { useHeader } from '../context/HeaderContext';
import { UserProfileCard } from '../components/pageComponents/managerUsers/UserProfileCard';
import { UserData } from '../types/manageUsers';
import InviteUserForm from '../components/pageComponents/managerUsers/InviteUserForm';
import DeleteAccountModal from '../components/pageComponents/managerUsers/DeleteAccountModal';
import iconlogout from '../assets/icons/deleteimg.png';
import CoachManageUsersSearchbar from '../components/pageComponents/managerUsers/CoachManageUsersSearchbar';
import MultiSelectDropdown from '../components/pageComponents/managerUsers/MultiSelectDropdown';
import ManageUsers, {
	User,
} from '../components/pageComponents/managerUsers/ManageUsers';
import styles from '../styles/pages/ManageUsersPage.module.css';
import addIcon from '../assets/profile/addicon.png';
import profile from '../assets/profile/profile.svg';
import { useCoachCourseDashboard } from '../hooks/useCoachCourseDashboard';
import { useUserProfile } from '../hooks/useUserProfile';
import profileDefault from '../assets/profile/profile.svg';
import { useCourseEnrollment } from '../hooks/useCourseEnrollment';
import { useCourseCatalog } from '../hooks/useCourse';
import SuccessContent from '../components/controlVariations/ModularSuccessModal';
import ResponsiveModal from '../components/controlVariations/ResponsiveModal';

// import styles from '../styles/pages/ManageUsersPage.module.css';
const dummyUser = {
	name: 'John Doe',
	email: 'john.doe@gmail.com',
	phone: '+91 9876543210',
	timezone: 'UTC +05:30',
	location: 'Mumbai, Maharashtra',
	country: 'India',
	program: 'IMPACT Level 1 ACC',
	role: 'Coachee',
	organization: 'ABC Pvt Ltd',
	professionalRole: 'Assistant Manager',
	areasOfInterest: ['ICF Coaching Credentials', 'Mentor', 'Mentoring'],
	coachingExperience: ['Personal Growth', 'Leadership Effectiveness'],
	growthWithIOCM: ['Building Coaching Capability'],
	avatarUrl: profile,
};

const ManageUsersPage: React.FC = () => {
	const { setHeaderContent } = useHeader();
	const [open, setOpen] = useState(false);
	const [checked, setChecked] = useState<boolean | 'indeterminate'>(false);
	const [selectedUser, setSelectedUser] = useState<User | null>(null);
	const [pendingProgramRemovals, setPendingProgramRemovals] = useState<
	{
		programName: string;
		enrollmentId: string;
	}[]
>([]);
	const [isInviteOpen, setIsInviteOpen] = useState(false);
	const { dashboard, loading, error, fetchDashboard } =
		useCoachCourseDashboard();
	const [mode, setMode] = useState<'view' | 'edit'>('view');
	const [userData, setUserData] = useState<UserData>(dummyUser);

	const {
		profile,
		fetchUserProfileById,
		loading: profileLoading,
		deleteUser,
		deleteLoading,
		deleteError,
		deleteSuccess,
	} = useUserProfile();

	const { deleteEnrollment, createEnrollment, isDeleting: enrollmentDeleting } =
		useCourseEnrollment();

	// const { courses: catalogCourses } = useCourseCatalog();

	const [values, setValues] = useState({
		fullName: '',
		email: '',
		phoneNumber: '',
		organizationName: '',
		enrolledPrograms: [],
		platformRole: '',
	});

	const [loggedInUserId, setLoggedInUserId] = useState<string | null>(null);

useEffect(() => {
    if (profile?.id && !loggedInUserId) {
        setLoggedInUserId(profile.id);
    }
}, [profile?.id, loggedInUserId]);

	const handleChange = (field: any, value: any) => {
		setValues(prev => ({
			...prev,
			[field]: value,
		}));
	};

	useEffect(() => {
		setHeaderContent(<p>Manage Users</p>);
	}, [setHeaderContent]);

	useEffect(() => {
		fetchDashboard(); // fetch all courses with attendees
	}, []);

	const handleSubmit = () => {
		console.log(values);
	};

	const mapRole = (roleName?: string): User['role'] => {
		if (!roleName) return null;

		switch (roleName.toLowerCase()) {
			case 'coachee':
				return 'learner';

			default:
				return 'learner';
		}
	};

	

const { courses: catalogCourses } = useCourseCatalog();
const apiUsers: User[] = React.useMemo(() => {
	if (!dashboard?.courses) return [];

	const userMap = new Map<string, User>();

	dashboard.courses.forEach(course => {
		const programTitle = course.course.title.split('(')[0].trim();

		course.enrolledcoachees.forEach(coachee => {
			const existing = userMap.get(coachee.userid);

			if (existing) {
				if (coachee.enrollmentid) {
					existing.enrollmentId.push(coachee.enrollmentid);

					existing.enrollments.push({
						programName: programTitle,
						enrollmentId: coachee.enrollmentid,
					});
				}

				const programs = existing.enrolledProgram
					? existing.enrolledProgram
							.split(',')
							.map(p => p.trim())
					: [];

				if (!programs.includes(programTitle)) {
					programs.push(programTitle);
				}

				existing.enrolledProgram = programs.join(', ');
			} else {
				userMap.set(coachee.userid, {
					id: coachee.userid,
					fullName: coachee.fullname,

					avatarUrl:
						coachee.profilepicture ||
						profile?.profilepicture ||
						profileDefault,

					enrolledProgram: programTitle,

					iccCredentials:
						coachee.metadata?.credentials || 'N/A',

					role: mapRole(coachee.rolename),

					enrollmentId: coachee.enrollmentid
						? [coachee.enrollmentid]
						: [],

					enrollments: coachee.enrollmentid
						? [
								{
									programName: programTitle,
									enrollmentId:
										coachee.enrollmentid,
								},
							]
						: [],

					canDelete: false,
				});
			}
		});
		// -----------------------------------------
// Add users who are not enrolled in any course
// -----------------------------------------
dashboard.unenrolledusers?.forEach(user => {
    // Don't add again if the user is already enrolled
    if (userMap.has(user.userid)) {
        return;
    }

    userMap.set(user.userid, {
        id: user.userid,
        fullName: user.fullname,
        avatarUrl:
            user.profilepicture ||
            profile?.profilepicture ||
            profileDefault,
        enrolledProgram: 'No Program',
        iccCredentials:
            user.metadata?.credentials || 'N/A',
        role: mapRole(user.rolename),
        enrollmentId: [],
        enrollments: [],
        canDelete: false,
    });
});
	});

	// -----------------------------------------
	// Calculate delete permission for every user
	// -----------------------------------------

	const users = Array.from(userMap.values()).map(user => {
		const canDelete =
			!!loggedInUserId &&
			!!catalogCourses?.length &&
			(user.enrollments?.some(enrollment => {
				return catalogCourses.some(course => {
					const courseProgramName = course.title
						.split('(')[0]
						.trim();

					return (
						courseProgramName === enrollment.programName &&
						course.status?.toLowerCase() === 'published' &&
						course.programownerid === loggedInUserId
					);
				});
			}) ??
				false);

		return {
			...user,
			canDelete,
		};
	});

	return users;
}, [
	dashboard,
	profile,
	loggedInUserId,
	catalogCourses,
]);

	
	const mapApiResponseToUserData = (
	apiData: any,
	enrolledProgram?: string
): UserData => {
	const roleName = apiData.rolename?.toLowerCase();

	let displayRole = '';

	if (roleName === 'coachee') {
		displayRole = 'Learner';
	} else if (roleName) {
		displayRole =
			roleName.charAt(0).toUpperCase() + roleName.slice(1);
	} else {
		displayRole = 'N/A';
	}

	return {
			name: apiData.fullname || '',
		email: apiData.email || '',
		phone: apiData.phonenumber || '',
		timezone: apiData.preferences?.timezone || 'UTC',
		location: apiData.location || '',
		country: apiData.country,
		
		enrolledProgram: enrolledProgram || '',
		platformRole: displayRole,
		organization: apiData.organizationname || '',
		professionalRole: apiData.designation || '',
		areasOfInterest: apiData.areasofinterest || [],
		coachingExperience: apiData.coachingexperience || [],
		growthWithIOCM: apiData.growthparameters || [],
		avatarUrl: apiData.profilepicture || profileDefault,
	};
};

	const [search, setSearch] = useState('');
	const [searchError, setSearchError] = useState('');
	const [selectedPrograms, setSelectedPrograms] = useState<string[]>([]);
	const [selectedCredentials, setSelectedCredentials] = useState<string[]>(
		[]
	);

	// const programOptions = React.useMemo(() => {
	// 	if (!catalogCourses || catalogCourses.length === 0) return [];

	// 	const uniquePrograms = new Map();

	// 	catalogCourses.forEach(course => {
	// 		// Remove everything after "("
	// 		const trimmedTitle = course.title.split('(')[0].trim();

	// 		if (!uniquePrograms.has(trimmedTitle)) {
	// 			uniquePrograms.set(trimmedTitle, {
	// 				label: trimmedTitle,
	// 				value: trimmedTitle,
	// 			});
	// 		}
	// 	});

	// 	return Array.from(uniquePrograms.values());
	// }, [catalogCourses]);
	

// const programOptions = React.useMemo(() => {
// 	if (!catalogCourses?.length) return [];

// 	const uniquePrograms = new Map();

// 	catalogCourses
// 		.filter(course => course.status?.toLowerCase() === 'published')
// 		.forEach(course => {
// 			const trimmedTitle = course.title.split('(')[0].trim();

// 			if (!uniquePrograms.has(trimmedTitle)) {
// 				uniquePrograms.set(trimmedTitle, {
// 					label: trimmedTitle,
// 					value: course.id,
// 				});
// 			}
// 		});

// 	return Array.from(uniquePrograms.values());
// }, [catalogCourses]);
console.log('========== PROGRAM DEBUG ==========');
console.log('Logged/current profile:', profile);
console.log('Current profile ID:', profile?.id);

console.log(
    'Catalog courses:',
    catalogCourses?.map(course => ({
        title: course.title,
        status: course.status,
        programownerid: course.programownerid,
        programownername: course.programownername,
    }))
);

console.log(
    'Matching programs:',
    catalogCourses?.filter(course =>
        course.status?.toLowerCase() === 'published' &&
        course.programownerid === profile?.id
    )
);
// const programOptions = React.useMemo(() => {
//     if (!catalogCourses?.length || !loggedInUserId) {
//         console.log('❌ No catalog courses or logged-in user ID', {
//             catalogCourses,
//             loggedInUserId,
//         });

//         return [];
//     }

//     console.log('👤 Logged-in coach ID:', loggedInUserId);

//     const uniquePrograms = new Map();

//     catalogCourses
//         .filter(course => {
//             const isPublished =
//                 course.status?.toLowerCase() === 'published';

//             const isOwner =
//                 course.programownerid === loggedInUserId;

//             console.log('🔎 Checking course:', course.title, {
//                 isPublished,
//                 isOwner,
//                 courseOwnerId: course.programownerid,
//                 loggedInUserId,
//             });

//             return isPublished && isOwner;
//         })
//         .forEach(course => {
//             const trimmedTitle = course.title.split('(')[0].trim();

//             if (!uniquePrograms.has(trimmedTitle)) {
//                 uniquePrograms.set(trimmedTitle, {
//                     label: trimmedTitle,
//                     value: course.id,
//                 });
//             }
//         });

//     const options = Array.from(uniquePrograms.values());

//     console.log('✅ FINAL PROGRAM OPTIONS:', options);

//     return options;
// }, [catalogCourses, loggedInUserId]);
const programOptions = React.useMemo(() => {
	if (!catalogCourses?.length || !loggedInUserId || !selectedUser) {
		return [];
	}

	const existingProgramNames =
		selectedUser.enrolledProgram
			?.split(',')
			.map(p => p.trim())
			.filter(Boolean) || [];

	const uniquePrograms = new Map();

	catalogCourses
		.filter(course => course.status?.toLowerCase() === 'published')
		.forEach(course => {
			const programName = course.title.split('(')[0].trim();

			const isOwner =
				course.programownerid === loggedInUserId;

			const isAlreadyEnrolled =
				existingProgramNames.includes(programName);

			/*
				Show the program when:
				1. Logged-in user owns it
				OR
				2. User is already enrolled in it
			*/
			if (!isOwner && !isAlreadyEnrolled) {
				return;
			}

			if (!uniquePrograms.has(programName)) {
				uniquePrograms.set(programName, {
					label: programName,
					value: course.id,

					// Existing programs owned by someone else
					// should be visible but disabled.
					disabled: !isOwner,
				});
			}
		});

	return Array.from(uniquePrograms.values());
}, [
	catalogCourses,
	loggedInUserId,
	selectedUser,
]);

const programOptionsForInvite = programOptions;

	const filteredUsers = apiUsers.filter(user => {
		const normalizedSearch = search.trim().toLowerCase();
		// ✅ Program filter
		const programMatch =
    selectedPrograms.length === 0 ||
    selectedPrograms.some(selectedProgram => {
        if (selectedProgram === 'No Program') {
            return (
                !user.enrolledProgram ||
                user.enrolledProgram.trim() === '' ||
                user.enrolledProgram.trim() === 'No Program'
            );
        }

        return user.enrolledProgram
            ?.split(',')
            .map(program => program.trim())
            .includes(selectedProgram);
    });

		// ✅ Credential filter
		const credentialMatch =
			selectedCredentials.length === 0 ||
			(user.iccCredentials &&
				selectedCredentials.includes(user.iccCredentials)) ||
			(!user.iccCredentials && selectedCredentials.includes('N/A'));
		// 🔥 REAL-TIME SEARCH FILTER
		const searchMatch = user.fullName
			?.toLowerCase()
			.includes(normalizedSearch);
		// user.enrolledProgram?.toLowerCase().includes(normalizedSearch) ||
		// user.role?.toLowerCase().includes(normalizedSearch);

		return programMatch && credentialMatch && searchMatch;
	});

	const credentialOptions = [
		{ label: 'ACC', value: 'ACC' },
		{ label: 'PCC', value: 'PCC' },
		{ label: 'MCC', value: 'MCC' },
		{ label: 'EMCC', value: 'EMCC' },
		{ label: 'N/A', value: 'N/A' },
	];

	const [isProfileOpen, setIsProfileOpen] = useState(false);
	const [profileMode, setProfileMode] = useState<'view' | 'edit'>('view');

	const [successState, setSuccessState] = useState<{
		open: boolean;
		title: string;
		subtitle: string;
	}>({
		open: false,
		title: '',
		subtitle: '',
	});

	const [isOnline, setIsOnline] = useState(navigator.onLine);

	useEffect(() => {
		const handleOnline = () => setIsOnline(true);
		const handleOffline = () => setIsOnline(false);

		window.addEventListener('online', handleOnline);
		window.addEventListener('offline', handleOffline);

		return () => {
			window.removeEventListener('online', handleOnline);
			window.removeEventListener('offline', handleOffline);
		};
	}, []);

// 	const getOwnedEnrollments = () => {
// 	if (!selectedUser || !loggedInUserId || !catalogCourses?.length) {
// 		return [];
// 	}

// 	const ownedEnrollments =
// 		selectedUser.enrollments?.filter(enrollment => {
// 			const matchingCourse = catalogCourses.find(course => {
// 				const courseProgramName = course.title
// 					.split('(')[0]
// 					.trim();

// 				return (
// 					courseProgramName === enrollment.programName
// 				);
// 			});

// 			if (!matchingCourse) {
// 				console.warn(
// 					`Course not found for program: ${enrollment.programName}`
// 				);

// 				return false;
// 			}

// 			const isOwner =
// 				matchingCourse.programownerid === loggedInUserId;

// 			console.log('Checking enrollment ownership:', {
// 				programName: enrollment.programName,
// 				enrollmentId: enrollment.enrollmentId,
// 				courseId: matchingCourse.id,
// 				courseOwner: matchingCourse.programownerid,
// 				loggedInUserId,
// 				isOwner,
// 			});

// 			return isOwner;
// 		}) || [];

// 	return ownedEnrollments;
// };
const getOwnedEnrollments = () => {
    if (!selectedUser || !loggedInUserId || !catalogCourses?.length) {
        console.log('❌ Missing data:', {
            selectedUser,
            loggedInUserId,
            catalogCourses,
        });

        return [];
    }

    console.log('================ OWNERSHIP DEBUG ================');
    console.log('Logged-in user ID:', loggedInUserId);
    console.log('Selected user:', selectedUser.fullName);
    console.log('Selected user ID:', selectedUser.id);
    console.log('User enrollments:', selectedUser.enrollments);

    const ownedEnrollments =
        selectedUser.enrollments?.filter(enrollment => {

            console.log('\n--------------------------------');
            console.log('Checking enrollment:', enrollment);

            const matchingCourses = catalogCourses.filter(course => {
                const courseProgramName = course.title
                    .split('(')[0]
                    .trim();

                const nameMatches =
                    courseProgramName === enrollment.programName;

                if (nameMatches) {
                    console.log('📌 Program name matched:', {
                        enrollmentProgram: enrollment.programName,
                        courseTitle: course.title,
                        courseId: course.id,
                        courseOwner: course.programownerid,
                        loggedInUserId,
                    });
                }

                return nameMatches;
            });

            console.log(
                'Matching courses for',
                enrollment.programName,
                ':',
                matchingCourses
            );

            const matchingCourse = matchingCourses.find(
                course => course.programownerid === loggedInUserId
            );

            console.log('Final matching owned course:', matchingCourse);

            if (!matchingCourse) {
                console.log(
                    '❌ NOT OWNED:',
                    enrollment.programName
                );

                return false;
            }

            console.log(
                '✅ OWNED:',
                enrollment.programName
            );

            return true;
        }) || [];

    console.log(
        '🔥 FINAL OWNED ENROLLMENTS:',
        ownedEnrollments
    );

    return ownedEnrollments;
};

	const handleProgramRemoveRequest = (removedPrograms: string[]) => {
	if (!selectedUser) return;

	const removals = removedPrograms
		.map(programName => {
			const enrollment = selectedUser.enrollments?.find(
				item => item.programName === programName
			);

			if (!enrollment?.enrollmentId) {
				console.warn(
					`Enrollment ID not found for program: ${programName}`
				);
				return null;
			}

			return {
				programName,
				enrollmentId: enrollment.enrollmentId,
			};
		})
		.filter(Boolean) as {
		programName: string;
		enrollmentId: string;
	}[];

	console.log('Programs selected for removal:', removals);

	setPendingProgramRemovals(removals);
	setChecked(false);
	setOpen(true);
};

	const handleConfirmDelete = async () => {
		if (!selectedUser) return;

		if (!isOnline) {
			return;
		}

		try {
			let title = '';
			let subtitle = '';

			
			if (pendingProgramRemovals.length > 0) {
	// =========================================
	// REMOVE ONLY THE PROGRAM(S) USER DESELECTED
	// =========================================

	await Promise.all(
		pendingProgramRemovals.map(item =>
			deleteEnrollment(item.enrollmentId)
		)
	);

	title = 'Program removed';

	subtitle =
		pendingProgramRemovals.length === 1
			? `${pendingProgramRemovals[0].programName} was removed from ${selectedUser.fullName}.`
			: `${pendingProgramRemovals.length} programs were removed from ${selectedUser.fullName}.`;

} else if (checked === true) {
	// =========================================
	// HARD DELETE USER
	// =========================================

	await deleteUser(
		selectedUser.id,
		'User requested deletion'
	);

	title = 'User deleted';

	subtitle = `${selectedUser.fullName}'s account and personal data were permanently removed.`;

} else {
	// =========================================
	// NORMAL REMOVE USER FROM ALL PROGRAMS
	// =========================================

	// if (selectedUser.enrollmentId?.length) {
	// 	await Promise.all(
	// 		selectedUser.enrollmentId.map(id =>
	// 			deleteEnrollment(id)
	// 		)
	// 	);
	// }

	// title = 'Enrollment removed';

	// subtitle = `${selectedUser.fullName} was successfully removed from the program.`;
	// =========================================
	// REMOVE USER ONLY FROM PROGRAMS
	// OWNED BY THE LOGGED-IN USER
	// =========================================

	const ownedEnrollments = getOwnedEnrollments();

	console.log(
		'Enrollments owned by logged-in user:',
		ownedEnrollments
	);

	if (ownedEnrollments.length > 0) {
		await Promise.all(
			ownedEnrollments.map(enrollment =>
				deleteEnrollment(enrollment.enrollmentId)
			)
		);
	}

	title = 'Enrollment removed';

	subtitle =
		ownedEnrollments.length === 1
			? `${selectedUser.fullName} was removed from ${ownedEnrollments[0].programName}.`
			: ownedEnrollments.length > 1
				? `${selectedUser.fullName} was removed from ${ownedEnrollments.length} programs owned by you.`
				: `${selectedUser.fullName} is not enrolled in any program owned by you.`;
}

			setOpen(false);
			setIsProfileOpen(false);

			// ✅ Show success modal
			setSuccessState({
				open: true,
				title,
				subtitle,
			});

			// ✅ Auto close after 3 sec
			setTimeout(() => {
				setSuccessState(prev => ({ ...prev, open: false }));
				fetchDashboard();
			}, 3000);
		} catch (err: any) {
			console.log(err.message);
		}
	};


const handleSaveUserProfile = async (updatedData: UserData) => {
	if (!selectedUser) return;

	try {
		// -----------------------------------------
		// Programs currently selected in dropdown
		// -----------------------------------------
		const selectedPrograms = updatedData.enrolledProgram
			? updatedData.enrolledProgram
					.split(',')
					.map((p: string) => p.trim())
					.filter(Boolean)
			: [];

		// -----------------------------------------
		// Programs user currently has
		// -----------------------------------------
		const existingPrograms = selectedUser.enrolledProgram
			? selectedUser.enrolledProgram
					.split(',')
					.map(p => p.trim())
					.filter(Boolean)
			: [];

		// -----------------------------------------
		// Find programs to ADD
		// -----------------------------------------
		const programsToAdd = selectedPrograms.filter(
			program => !existingPrograms.includes(program)
		);

		// -----------------------------------------
		// Find programs to REMOVE
		// -----------------------------------------
		const programsToRemove = existingPrograms.filter(
			program => !selectedPrograms.includes(program)
		);

		console.log('Existing programs:', existingPrograms);
		console.log('Selected programs:', selectedPrograms);
		console.log('Programs to add:', programsToAdd);
		console.log('Programs to remove:', programsToRemove);

		// =========================================
		// 1. ADD NEW PROGRAMS
		// =========================================

		for (const program of programsToAdd) {
			const courseId = programOptions.find(
				p => p.label === program
			)?.value;

			if (!courseId) {
				console.warn(
					`Course ID not found for program: ${program}`
				);
				continue;
			}

			await createEnrollment({
				courseid: courseId,
				userid: selectedUser.id,
			});
		}

		// =========================================
		// 2. REMOVE ONLY DESELECTED PROGRAMS
		// =========================================

		for (const program of programsToRemove) {
			const enrollment = selectedUser.enrollments?.find(
				item => item.programName === program
			);

			if (!enrollment?.enrollmentId) {
				console.warn(
					`Enrollment ID not found for program: ${program}`
				);
				continue;
			}

			console.log(
				`Removing ${program} using enrollment ${enrollment.enrollmentId}`
			);

			await deleteEnrollment(enrollment.enrollmentId);
		}

		// =========================================
		// 3. UPDATE LOCAL PROFILE
		// =========================================

		setUserData(updatedData);
		setProfileMode('view');

		// =========================================
		// 4. SUCCESS
		// =========================================

		setSuccessState({
			open: true,
			title: 'Profile Updated',
			subtitle: `${updatedData.name}'s profile has been updated successfully.`,
		});

		// =========================================
		// 5. REFRESH DATA
		// =========================================

		await fetchDashboard();

		setTimeout(() => {
			setSuccessState(prev => ({
				...prev,
				open: false,
			}));
		}, 3000);
	} catch (err: any) {
		console.error('Error updating user programs:', err);
	}
};
const getCatalogProgramOptions = () => {
    if (!catalogCourses?.length) {
        return [];
    }

    const uniquePrograms = new Map<string, {
        label: string;
        value: string;
    }>();

    catalogCourses
        .filter(course => course.status?.toLowerCase() === 'published')
        .forEach(course => {
            const programName = course.title.split('(')[0].trim();

            if (!uniquePrograms.has(programName)) {
                uniquePrograms.set(programName, {
                    label: programName,
                    value: programName,
                });
            }
        });

    return Array.from(uniquePrograms.values());
};
const catalogProgramOptions = React.useMemo(() => {
    const programs = getCatalogProgramOptions();

    return [
        {
            label: 'No Program',
            value: 'No Program',
        },
        ...programs,
    ];
}, [catalogCourses]);

	return (
		<>
			{/* ===== HEADER ===== */}
			<div className={styles.header}>
				{/* LEFT SIDE */}
				<div className={styles.leftSection}>
					<div className={styles.leftSectionSerach}>
						<CoachManageUsersSearchbar
							value={search}
							// onChange={(e) => setSearch(e.target.value)}
							onChange={e => {
								const value = e.target.value;

								// Allow only letters and spaces
								const isValid = /^[a-zA-Z\s]*$/.test(value);

								if (isValid) {
									setSearch(value);
									setSearchError(''); // clear error
								} else {
									setSearchError(
										'Only letters and spaces are allowed'
									);
								}
							}}
						/>
						{searchError && (
							<p className={styles.searchError}>{searchError}</p>
						)}
					</div>

					<div className={styles.dropdown}>
						<MultiSelectDropdown
							// options={programOptions}
							 options={catalogProgramOptions}
							selectedValues={selectedPrograms}
							onChange={setSelectedPrograms}
							placeholder="Enrolled Program"
							width="209px"
						/>

						<MultiSelectDropdown
							options={credentialOptions}
							selectedValues={selectedCredentials}
							onChange={setSelectedCredentials}
							placeholder="ICC Credentials"
							width="209px"
						/>
					</div>
				</div>
			</div>

			{loading && <p>Loading users...</p>}
			{error && <p style={{ color: 'red' }}>{error}</p>}
			<ManageUsers
				users={filteredUsers}
				pageSize={10}
				onView={async user => {
					setSelectedUser(user);
					setProfileMode('view');
					setIsProfileOpen(true);

					try {
						const apiResponse = await fetchUserProfileById(user.id); // returns LearnerProfile

						if (apiResponse) {
							// Map API response to UserData format
							console.log('particular user data ', apiResponse);
							const mappedData = mapApiResponseToUserData(
								apiResponse,
								user.enrolledProgram
							);

							setUserData(mappedData); // now UserProfileCard will show real data
						}
					} catch (err) {
						console.error('Error fetching user profile:', err);
					}
				}}
				onDelete={user => {
					setSelectedUser(user); // store which user is being deleted
					setChecked(false); // reset checkbox
					setOpen(true); // open modal
				}}
				onEdit={async user => {
        setSelectedUser(user);

        // Important: open directly in edit mode
        setProfileMode('edit');

        setIsProfileOpen(true);

        try {
            const apiResponse = await fetchUserProfileById(user.id);

            if (apiResponse) {
                console.log('Edit user data:', apiResponse);

                const mappedData = mapApiResponseToUserData(
                    apiResponse,
                    user.enrolledProgram
                );

                setUserData(mappedData);
            }
        } catch (err) {
            console.error('Error fetching user profile:', err);
        }
    }}

			/>
			<DeleteAccountModal
				open={open}
				icon={iconlogout}
				title={`Are you sure to remove  ${selectedUser?.fullName} from the program?`}
				confirmText="Remove User"
				cancelText="Keep Account"
				onConfirm={handleConfirmDelete}
				onCancel={() => setOpen(false)}
				// showCheckbox 
				checkboxLabel="Delete the user from the platform"
				checkboxChecked={checked}
				onCheckboxChange={setChecked}
				// disableConfirm={!isOnline}
				disableConfirm={
					!isOnline || deleteLoading || enrollmentDeleting
				}
			/>

			

			{isProfileOpen && selectedUser && (
				<UserProfileCard
					mode={profileMode}
					title={
						profileMode === 'view'
							? 'View User Profile'
							: 'Edit User Profile'
					}
					programOptions={programOptionsForInvite}
					data={userData} // you can replace with mapped selectedUser data
					showEdit={true}
					showDelete={false}
					showClose={true}
					showUndo={true}
					showSave={true}
					onEdit={() => setProfileMode("edit")}
					onClose={() => setIsProfileOpen(false)}
					// onDelete={() => {
					// 	setChecked(false); // reset checkbox
					// 	setOpen(true); // open delete modal
					// }}
					onDelete={(removedPrograms?: string[]) => {
	if (removedPrograms && removedPrograms.length > 0) {
		handleProgramRemoveRequest(removedPrograms);
		return;
	}

	// Normal delete button
	setPendingProgramRemovals([]);
	setChecked(false);
	setOpen(true);
}}
					onUndo={() => setProfileMode('view')}
					onSave={handleSaveUserProfile}
				/>
			)}
			{successState.open && (
				<div className={styles.modalOverlay}>
					<ResponsiveModal
						open={successState.open}
						onClose={() =>
							setSuccessState(prev => ({ ...prev, open: false }))
						}
					>
						<SuccessContent
							title={successState.title}
							subtitle={successState.subtitle}
						/>
					</ResponsiveModal>
				</div>
			)}
		</>
	);
};

export default ManageUsersPage;
